import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";

import Spinner from 'react-loader-spinner';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

function UpgradePlan() {
    const dispatch = useDispatch();
    const chargeProps = useSelector(state => state.charge);

    useEffect(() => {
        dispatch({
            type: "CREATE_RECURRING_CHARGE",
            payload: {
                page: "dashboard"
            }
        });
    }, []);

    useEffect(() => {
        if (!isEmpty(chargeProps)) {
            window.location.href = chargeProps.recurring_application_charge.confirmation_url;
        }
    }, [chargeProps]);

    return (
        <div className="loaderContainer">
            <Spinner type="Rings" color="Black" height={150} width={150} visible={true} />
        </div>
    );
}

export default UpgradePlan;